<template>
  <div>
    <b-card title="دریافت فایل اکسل برای بارگذاری">
      <b-button class="btn btn-success" @click="download">دریافت فایل</b-button>
    </b-card>
  </div>
</template>
<script>
import TableShowData from "../../components/table";
import httpHelper from "../../helpers/httpHelper";
import { saveExcel } from "@progress/kendo-vue-excel-export";
export default {
  name: "shaparakReferral",
  data() {
    return {
      url: "",
      params: [],
      fields: [],
    };
  },
  methods: {
    download() {
      httpHelper
        .getData("~reports/api/transaction/shaparak-export")
        .then((res) => {
          saveExcel({
            data: res.result.excel,
            fileName: "myFile",
            columns: res.result.columns,
          });
        });
    },
  },
  components: {
    "list-table": TableShowData,
  },
};
</script>